import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';

import { catchError, throwError } from 'rxjs';

import { ToastService } from '../components/wally-ui/toast/lib/services/toast.service';
import { IZA_CONFIG } from '../iza-config';

let isLoggingOut: boolean = false;

export const auth0ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(IZA_CONFIG);
  // ahri only: the autosync URL is shared with the host, and a 401/403 on the host's
  // own autosync call must NOT force-logout the whole session. ahri is Iza-exclusive.
  const isAhriUrl = req.url.startsWith(config.ahriApiUrl);

  if (!isAhriUrl) {
    return next(req);
  }

  const auth0 = inject(AuthService);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401 || error.status === 403) {
          const isAuth0Request = req.url.includes('auth0.com');

          if (!isAuth0Request && !isLoggingOut) {
            console.warn(`Sessão recusada pela API (${error.status}). Iniciando logout...`);
            isLoggingOut = true;

            toastService.create({
              type: 'warning',
              message: 'Sua sessão expirou. Você será redirecionado para o login.',
              duration: 5000,
            });

            auth0.logout({
              logoutParams: { returnTo: window.location.origin },
            });
          }
        }
      }

      return throwError(() => error);
    })
  );
};
